import { SFCheckIcon, ACTION_BAR_ACTION_NAMES, ACTION_BAR_ACTION_TYPES } from "@sf-core";


export const getActionDefs = (params) => {
  const {
    t,
    onCancelClick = () => {},
    onSaveClick  = () => {},
    onDeleteClick  = () => {},
    onRestoreClick  = () => {},
    userDataProps,
  } = params;

  return [
    {
      name: ACTION_BAR_ACTION_NAMES.CANCEL,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: onCancelClick,
      buttonProps: {
        label: t("components.toolbar.templates.cancel"),
        variant: "secondary",
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.SAVE,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      onClick: onSaveClick,
      buttonProps: {
        label: t("usersScreen.userProfileScreen.saveButton"),
        variant: "primary",
        icon: <SFCheckIcon size="small" />,
        iconPlacement: "start",
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        header: t("usersScreen.userProfileScreen.saveConfirmationModalHeader"),
        message: t(
          "usersScreen.userProfileScreen.saveConfirmationModalMessage"
        ),
      },
    },
    {
      name: ACTION_BAR_ACTION_NAMES.DELETE,
      type: ACTION_BAR_ACTION_TYPES.BUTTON,
      disabled: !userDataProps.isActive,
      onClick: onDeleteClick,
      buttonProps: {
        label: t("usersScreen.userProfileScreen.deleteButton"),
        variant: "primary",
        iconPlacement: "start",
        async: true,
      },
      confirmation: true,
      confirmationProps: {
        header: t(
          "usersScreen.userProfileScreen.deleteConfirmationModalHeader"
        ),
        message: t(
          "usersScreen.userProfileScreen.deleteConfirmationModalMessage"
        ),
        variant: "info",
      },
    },
    ...(!userDataProps.isActive
      ? [ {
        name: "restore",
        type: ACTION_BAR_ACTION_TYPES.BUTTON,
        disabled: userDataProps.isActive,
        onClick: onRestoreClick,
        buttonProps: {
          label: t("usersScreen.userProfileScreen.restoreButton"),
          variant: "primary",
          iconPlacement: "start",
          async: true,
        },
        confirmation: true,
        confirmationProps: {
          header: t(
            "usersScreen.userProfileScreen.restoreConfirmationModalHeader"
          ),
          message: t(
            "usersScreen.userProfileScreen.restoreConfirmationModalMessage"
          ),
          variant: "info",
        },
      },]
      : [])
   
  ];
};



export default getActionDefs;
